import { configModel } from 'APP/model/model';
import { initUnauthorizedCallHostConfigClient } from 'APP/restApi/rest/hostConfig';
import Entities from 'STORE';

export async function updateUnauthorizedHostConfig(deeplinkUrl: string): Promise<boolean> {
  try {
    const url = new URL(deeplinkUrl);
    const baseUrl = url.origin;
    initUnauthorizedCallHostConfigClient(baseUrl);

    const hostConfig = await configModel.getUnauthorizedCallHostConfig();

    if (!hostConfig) {
      Entities.clientConfig.resetHostConfig();
      return false;
    }
    Entities.clientConfig.setHostConfig(hostConfig);
    return true;
  } catch {
    Entities.clientConfig.resetHostConfig();
    return false;
  }
}
